import React from 'react'
import { Box } from 'theme-ui'

export default function FeaturesDivider(): React.ReactElement {
  return (
    <Box
      sx={{
        display: ['none', 'block'],
        border: '3px solid',
        borderColor: 'black',
        opacity: '0.1',
        height: '16rem',
      }}
    />
  )
}
